/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    makeAsyncReducer,
    asyncDefaults,
    mergeReducers,
} from 'ui-lottery/src/utils/async_utils';
import { PREFIX } from '../constants';
import { FETCH_PERMIT_TYPES } from '../constants/actions';
import { RootState } from '../../dev/store';

const fetchPermitTypes = makeAsyncReducer(FETCH_PERMIT_TYPES);

export default mergeReducers(asyncDefaults([]), PREFIX, fetchPermitTypes);

export const selectors = {
    getPermitTypes: (state: RootState) => state.treePermit?.permitTypes?.data,
};
